import { type LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

interface StatsCardProps {
  icon: LucideIcon
  label: string
  value: string | number
  accent?: boolean
}

export default function StatsCard({ icon: Icon, label, value, accent }: StatsCardProps) {
  return (
    <div className="card p-6">
      <div className="flex items-center gap-4">
        <div className={cn(
          'p-3 rounded-lg',
          accent ? 'bg-accent-900/30 text-accent-400' : 'bg-dark-800 text-primary-400'
        )}>
          <Icon className="h-6 w-6" />
        </div>

        <div>
          <p className="text-2xl font-bold text-white">{value}</p>
          <p className="text-sm text-dark-400">{label}</p>
        </div>
      </div>
    </div>
  )
}
